import { render, staticRenderFns } from "./CurrentProductionStats.vue?vue&type=template&id=9d345378&scoped=true&"
import script from "./CurrentProductionStats.vue?vue&type=script&lang=js&"
export * from "./CurrentProductionStats.vue?vue&type=script&lang=js&"
import style0 from "./CurrentProductionStats.vue?vue&type=style&index=0&id=9d345378&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d345378",
  null
  
)

export default component.exports